import {Directive, ElementRef, Renderer2, OnDestroy} from '@angular/core';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import {LayoutService} from './layout.service';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[myPreloader]',
  standalone: false,
})
export class PreloaderDirective implements OnDestroy {
  subscription: Subscription;
  private routerSubscription: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private layoutService: LayoutService,
  ) {
    this.routerSubscription = router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });

    this.subscription = layoutService.preloaderState$.subscribe(state => {
      this.updatePreloader(state);
    });
  }

  active() {
    this.renderer.removeClass(this.el.nativeElement, 'hide');
    this.renderer.addClass(this.el.nativeElement, 'active');
  }

  hide() {
    this.renderer.addClass(this.el.nativeElement, 'hide');
    this.renderer.removeClass(this.el.nativeElement, 'active');
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      //this.active()
    }
    if (event instanceof NavigationEnd) {
      //this.hide()
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.hide();
    }
    if (event instanceof NavigationError) {
      this.hide();
    }
  }

  //
  updatePreloader(state) {
    // console.log('change state')
    if (state === 'active') {
      this.active();
    }

    if (state === 'hide') {
      this.hide();
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }
}
